import React from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronRightIcon, XIcon } from "lucide-react";
import { Logo } from "./Logo";
import { collections } from "../data/collections";
import { ease } from "../utils/styles";
interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}
export function MobileMenu({
  open,
  onClose
}: MobileMenuProps) {
  return <AnimatePresence data-id="element-277" data-mp="2ftge5wdyovca">
      {open && <>
          <motion.div className="fixed inset-0 z-50 bg-ink/40 lg:hidden" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-278" data-mp="2jvl4om945bup" />
          <motion.nav aria-label="Mobiele navigatie" className="fixed inset-y-0 left-0 z-50 flex w-[88%] max-w-sm flex-col bg-paper lg:hidden" initial={{
        x: "-100%"
      }} animate={{
        x: 0
      }} exit={{
        x: "-100%"
      }} transition={{
        duration: 0.28,
        ease
      }} data-id="element-279" data-mp="2tlmq16a30g5x">
            <div className="flex h-[72px] items-center justify-between border-b border-line px-5" data-id="element-280" data-mp="1tid2rg4xdpte">
              <Logo data-id="element-281" data-mp="1oh783crpfsh8" />
              <button type="button" onClick={onClose} className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-sand" aria-label="Menu sluiten" data-id="element-282" data-mp="1ognrq0hpdc5b">
                <XIcon className="h-5 w-5" data-id="element-283" data-mp="1fic2o2whimez" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-5 py-6" data-id="element-284" data-mp="2c7jolc10mxjf">
              <p className="text-sm text-muted" data-id="element-285" data-mp="2c9xivinvg5px">Shop</p>
              <ul className="mt-2" data-id="element-286" data-mp="278gjjrl1crbg">
                {collections.map(c => <li key={c.id} data-id="element-287" data-mp="22hrpq5lvvi95">
                    <Link to={c.filter === "Alles" ? "/shop" : `/shop?categorie=${c.filter}`} onClick={onClose} className="flex items-center gap-4 py-2.5" data-id="element-288" data-mp="22gp1k5fy3twx">
                      <img src={c.image} alt="" className="h-12 w-12 rounded-lg object-cover" data-id="element-289" data-mp="2uy2icdxhx4ix" />
                      <span className="flex-1 text-lg font-medium text-ink" data-id="element-290" data-mp="2q7uhslpsso7r">{c.title}</span>
                      <ChevronRightIcon className="h-4 w-4 text-muted" data-id="element-291" data-mp="oa24qml0kfz3" />
                    </Link>
                  </li>)}
              </ul>
              <ul className="mt-6 space-y-1 border-t border-line pt-6" data-id="element-292" data-mp="t8ls8rf99ztk">
                {[{
              label: "Alle producten",
              to: "/shop"
            }, {
              label: "Maatwerk aanvragen",
              to: "/#maatwerk"
            }, {
              label: "Winkelwagen",
              to: "/winkelwagen"
            }].map(l => <li key={l.label} data-id="element-293" data-mp="5lnfa3qcha0e">
                    <Link to={l.to} onClick={onClose} className="block py-2 text-[16px] text-ink" data-id="element-294" data-mp="aidrgfz13lgj">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </motion.nav>
        </>}
    </AnimatePresence>;
}